import { Component } from '@theme/component';
import { ThemeEvents } from '@theme/events';
import { formatMoney } from '@theme/money-formatting';

/**
 * A custom element that manages the free shipping progress bar.
 * Updates dynamically when the cart is modified.
 */
class FreeShippingBar extends Component {
  connectedCallback() {
    super.connectedCallback();

    // Initialize with current cart total
    const initialCartTotal = parseInt(this.dataset.cartTotal, 10) || 0;
    this.updateProgress(initialCartTotal);

    // Listen to cart update events
    document.addEventListener(ThemeEvents.cartUpdate, this.handleCartUpdate.bind(this));
  }

  handleCartUpdate(event) {
    if (event.detail && event.detail.resource && event.detail.resource.total_price !== undefined) {
      this.updateProgress(event.detail.resource.total_price);
    } else {
      // Fetch the cart manually if the event doesn't provide the total_price (e.g. add to cart)
      fetch('/cart.js')
        .then(response => response.json())
        .then(cart => {
          this.updateProgress(cart.total_price);
        })
        .catch(error => console.error('Error fetching cart:', error));
    }
  }

  updateProgress(cartTotal) {
    const threshold = parseInt(this.dataset.threshold, 10);
    const progressText = this.dataset.progressText || 'Envío gratis a partir de [amount]';
    const successText = this.dataset.successText || '¡Felicidades! Tienes envío gratis';
    const moneyFormat = this.dataset.moneyFormat || '${{amount}}';
    const currency = this.dataset.currency || 'MXN';

    const remaining = threshold - cartTotal;

    const messageContainer = this.querySelector('.free-shipping-bar__message');
    const progressBar = this.querySelector('.free-shipping-bar__progress-fill');
    
    if (!messageContainer) return;

    // Update text
    if (remaining > 0) {
      const formattedRemaining = formatMoney(remaining, moneyFormat, currency);
      // Create a span for the amount to allow specific styling if needed
      const amountSpan = `<span class="free-shipping-bar__amount">${formattedRemaining}</span>`;
      messageContainer.innerHTML = progressText.replace('[amount]', amountSpan);
    } else {
      messageContainer.innerHTML = successText;
    }

    // Update progress bar if it exists
    if (progressBar) {
      let progressPercentage = 0;
      if (threshold > 0) {
        progressPercentage = Math.min(100, (cartTotal / threshold) * 100);
      }
      progressBar.style.width = `${progressPercentage}%`;
    }
  }
}

if (!customElements.get('free-shipping-bar')) {
  customElements.define('free-shipping-bar', FreeShippingBar);
}
